import React from 'react';

import { TextInput } from '@shared/forms/components/TextField';
import { Badge } from '@shared/ui/components/Badge';
import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';

import { defaultError, defaultSuccess, goToTop } from '../../libs/utils';
import {
  confirmTwoFactorAuthentication,
  disableTwoFactorAuthentication,
  enableTwoFactorAuthentication,
  getRecoveryCodes,
  getTwoFactorQrCode,
} from '../../services/api/auth';
import '../../styles/vendor/react-checkbox-tree.css';

export default class EnableTwoFactorForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      twoFactorEnabled: props.user?.twoFactorEnabled ?? false,
      twoFactorConfirmed: props.user?.twoFactorEnabled ?? false,
      twoFactorQr: '',
      twoFactorQrLink: '',
      challenge: '',
      error: '',
      recoveryCodes: [],
    };
  }

  componentDidMount() {
    getRecoveryCodes().then((response) => {
      console.debug(response);
      this.setState({
        recoveryCodes: response.data,
      });
    });
  }

  enableTwoFactor() {
    enableTwoFactorAuthentication()
      .then(async (response) => {
        const code = await getTwoFactorQrCode();

        this.setState({
          twoFactorConfirmed: false,
          twoFactorQr: code.svg,
          twoFactorQrLink: code.url,
        });
      })
      .catch((e) => {
        defaultError(e.response.data.message);
        goToTop();
      });
  }

  disableTwoFactor() {
    disableTwoFactorAuthentication()
      .then(() => {
        this.setState({
          twoFactorEnabled: false,
          twoFactorConfirmed: false,
          twoFactorQr: '',
          twoFactorQrLink: '',
          challenge: '',
          error: '',
          recoveryCodes: [],
        });
      })
      .catch((e) => {
        defaultError(e.response.data.message);
        goToTop();
      });
  }

  onChallengeChanged = (challenge) => {
    this.setState({
      challenge,
    });
  };

  confirmTwoFactor() {
    confirmTwoFactorAuthentication(this.state.challenge)
      .then((response) => {
        defaultSuccess('Two Factor Confirmed!');
        getRecoveryCodes().then((response) => {
          this.setState({
            twoFactorEnabled: true,
            twoFactorConfirmed: true,
            recoveryCodes: response.data,
          });
        });
      })
      .catch((e) => {
        defaultError(e.response.data.message);
      });
  }

  render() {
    if (this.state.twoFactorEnabled && this.state.twoFactorConfirmed) {
      return (
        <div className="m-form m-form--fit m-form--label-align-right">
          <div className="form-group m-form__group row">
            <div className="col-10">
              <TwoFactorStatus enabled />
              <div className="m-form__seperator"></div>

              <h3 className="text-xl font-medium text-gray-700 py-1 mt-4">Recovery Codes</h3>
              <pre className="mt-4 mb-8 bg-gray-100 p-4 rounded w-fit">
                {this.state.recoveryCodes.map((code, index) => {
                  return `${code}\n`;
                })}
              </pre>

              <div className="m-form__seperator"></div>

              <div className="flex flex-row justify-between my-4 items-center">
                <h3 className="text-xl font-medium text-gray-700 py-1">Disable Two Factor Authentication</h3>

                <Button variant="destructive" disabled={this.props.loading} onClick={this.disableTwoFactor.bind(this)}>
                  Disable
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="m-form m-form--fit m-form--label-align-right">
        <div className="form-group m-form__group row">
          <div className="col-10">
            {this.state.twoFactorQr === '' && (
              <div>
                <TwoFactorStatus />
                <h3 className="text-xl font-medium text-gray-700 py-1 mb-4">Enable Two Factor Authentication</h3>
                {/*<button*/}
                {/*  key="1"*/}
                {/*  className={*/}
                {/*    'btn btn-accent m-btn m-btn--air m-btn--custom' +*/}
                {/*    (this.props.loading ? ' m-loader m-loader--light m-loader--left' : '')*/}
                {/*  }*/}
                {/*  onClick={this.enableTwoFactor.bind(this)}*/}
                {/*>*/}
                {/*  Enable*/}
                {/*</button>*/}
                <Button disabled={this.props.loading} onClick={this.enableTwoFactor.bind(this)}>
                  <Icon icon="lock" />
                  Enable
                </Button>
              </div>
            )}
            {this.state.twoFactorQr !== '' && (
              <div>
                <h3 className="m-form__section">Scan this code with your authenticator app:</h3>
                <a href={this.state.twoFactorQrLink}>
                  <div dangerouslySetInnerHTML={{ __html: this.state.twoFactorQr }}></div>
                </a>

                <h3 className="m-form__section">Confirm with the code from your authenticator app:</h3>
                <TextInput
                  placeholder="Code"
                  name="challenge"
                  onChange={this.onChallengeChanged}
                  value={this.state.challenge}
                />
                <button
                  key="2"
                  className={
                    'btn btn-accent m-btn m-btn--air m-btn--custom' +
                    (this.props.loading ? ' m-loader m-loader--light m-loader--left' : '')
                  }
                  onClick={this.confirmTwoFactor.bind(this)}
                >
                  Confirm Challenge
                </button>

                {this.state.error !== '' && <div className="alert alert-danger">{this.state.error}</div>}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function TwoFactorStatus({ enabled = false }) {
  return (
    <div className="mb-8">
      <div className="flex gap-2  mb-4 | text-xl font-medium text-gray-700 py-1">
        {enabled ? (
          <Badge variant="success">
            <Icon icon="lock" />
            Enabled
          </Badge>
        ) : (
          <Badge variant="destructive">
            <Icon icon="close" />
          </Badge>
        )}
        <span>Two Factor Authentication is {enabled ? 'enabled' : 'disabled'}</span>
      </div>

      <p>
        When two factor authentication is enabled, you will be prompted for a secure, random token during
        authentication. You may retrieve this token from your phone's Google Authenticator application.
      </p>
    </div>
  );
}
